import { render } from "./SnippetImageSlider.vue?vue&type=template&id=efa0c740"
import script from "./SnippetImageSlider.vue?vue&type=script&lang=js"
export * from "./SnippetImageSlider.vue?vue&type=script&lang=js"

import "./SnippetImageSlider.vue?vue&type=style&index=0&id=efa0c740&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__